import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/home';
import Login from '@/views/login';
import Register from '@/views/register';
import SentencingRegister from '@/views/thirdParty/sentencingRegister';
import ResearchDashboard from '@/views/researchPoint/researchDashboard';
import Report from '@/views/researchPoint/report';
import ResearchPoint from '@/views/researchPoint';
import DataCleaner from '@/views/dataCleaner';
import wechatLogin from '@/views/wechatLogin';
import Center from '@/views/center';
import Product from '@/views/product';
import Invite from '@/views/invite';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { noAuth: true }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: { noAuth: true }
  },
  {
    path: '/sentencing-register',
    name: 'sentencingRegister',
    component: SentencingRegister,
    meta: { noAuth: true, continueRoute: true, documentTitle: '小包公—智能量刑预测系统' }
  },
  {
    path: '/wechat/login',
    name: 'wechatLogin',
    component: wechatLogin,
    meta: { noAuth: true }
  },
  {
    path: '/research-dashboard',
    name: 'researchDashboard',
    component: ResearchDashboard
  },
  {
    path: '/report',
    name: 'report',
    component: Report
  },
  {
    path: '/case-research',
    name: 'caseResearch',
    component: ResearchPoint
  },
  {
    path: '/data-cleaner',
    name: 'dataCleaner',
    component: DataCleaner
  },
  {
    path: '/center',
    name: 'center',
    component: Center
  },
  {
    path: '/invite',
    name: 'invite',
    component: Invite
  },
  {
    path: '/product',
    name: 'product',
    component: Product,
    meta: { noAuth: true, continueRoute: true }
  }
];

const router = new VueRouter({
  routes
});

export default router;
